import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface AllAgentState {
  data: [] | null | any;
  currentPage: number | null;
  totalRecords: number | null;
  totalPages: number | null;
  allAgentsList: any[]; 
}

const initialState: AllAgentState = {
  data: null,
  totalRecords: null,
  totalPages: null,
  currentPage: null,
  allAgentsList: [], 
};

export const allAgentMasterSlice = createSlice({
  name: 'agentMaster',
  initialState,
  reducers: {
    setAgentMaster: (state, action) => {
      state.data = action.payload.data.content;
      state.totalRecords = action.payload.data.totalElements;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.number;
    },
    setAgentMasterBySearch: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.currentPage;
    },
    setAllAgentMaster: (state, action) => {
      state.allAgentsList = action.payload.data; // no pagination
    },
    reset: (state) => {
      state = initialState;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setAgentMaster,setAgentMasterBySearch, reset ,setAllAgentMaster} = allAgentMasterSlice.actions;
export const getAgentMasterDetails = (state: RootState) => state.agentMaster.data;
export const getAgentMasterDetailsBySearch = (state: RootState) => state.agentMaster.data;
export const getAgentMasterTotalRecords = (state:RootState)=>state.agentMaster.totalRecords;
export const getAllAgentMasterList = (state: RootState) => state.agentMaster.allAgentsList;
export default allAgentMasterSlice.reducer;